<div class="export-buttons-container">
  <!-- <button class="btn btn-sm btn-dark" (click)="zoomIn()">Zoom In</button>
    <button class="export-button" (click)="zoomOut()">Zoom Out</button> -->
  <button class="export-button" (click)="exportToCSV()">Export to CSV</button>
  <button class="export-button" (click)="exportToPDF()">Export to PDF</button>
</div>
<div class="grid-container">
  <ag-grid-angular #agGrid class="ag-theme-alpine" style="width: 100%; height: 90vh;" [rowData]="rowData"
    [rowHeight]="28" [headerHeight]="32" [columnDefs]="columnDefs" [sideBar]="sideBar"  [pivotMode]="true" 
    [rowGroupPanelShow]="rowGroupPanelShow" [animateRows]="true" (gridReady)="onGridReady($event)"  [autoGroupColumnDef]="autoGroupColumnDef">
  </ag-grid-angular>
</div>